module.exports = "<i ng-if=\"icon\"\n  class=\"{{$root.styles.icons.prefix}}\"\n  ng-bind-html=\"icon\">\n</i>\n\n<label for=\"{{id}}\">\n  <span ng-bind-html=\"label\"></span>\n  <span ng-if=\"required\"\n    class=\"asterisk\"> *</span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/inputs/myField.html
// module id = 1221
// module chunks = 0